import { Component } from '@angular/core';

@Component({
    selector: 'app-auth-shell-background',
    templateUrl: './auth-shell-background.component.html',
    styleUrls: ['./auth-shell-background.component.scss'],
    standalone: true,
})
export class AuthShellBackgroundComponent {}
